<div class="field-group"
     [class.origami-updated]="isUpdatedByOrigami"
>
  <p-iftalabel class="w-full">
    @if (control(); as ctrl) {
      <p-inputnumber class="w-full"
                     [currency]="currency()"
                     [formControl]="ctrl"
                     [id]="inputId()"
                     [invalid]="showInvalidState"
                     [max]="maxValue() ?? null"
                     [minFractionDigits]="fractionDigits() ?? null"
                     [min]="minValue() ?? null"
                     [mode]="mode()"
                     [showButtons]="showButtons()"
      />
    }
    <label class="block font-medium mb-1"
           [for]="inputId()"
    >{{ label() }}</label>
  </p-iftalabel>
  @if (showRequiredHint) {
    <small class="block text-red-500 text-xs mt-1">{{ label() }} is required.</small>
  }
</div>
